<template>
  <div class="h-100 my-5">
    <b-button
      type="submit"
      class="myButton"
      @click="$router.go(-1)">
      {{ $t('common.Cancel') }}
    </b-button>
    <div class="dp02 p-3 mt-3 row">
      <div class="text-center col-lg-12">
        <h2>{{ $t('EditProductVoucher.Header') }}</h2>
      </div>
      <ValidationObserver
        ref="observer"
        v-slot="{invalid}"
        tag="form"
        class="col-lg-12 mt-5"
        @submit.prevent="submit()">
        <div class="col-lg-12 row mt-3"
             v-show="voucherType === 2">
          <div class="col-lg-1 offset-lg-4">
            <label for="forWho">{{ $t('fields.forWho') }}</label>
          </div>
          <div class="col-lg-3">
            <ValidationProvider
              name="forWho"
              :rules="voucherType === 2 ? 'required' : ''"
              v-slot="{errors, classes}">
              <b-form-input
                id="forWho"
                v-model="forWho"
                :class="{...classes, myInput: true}" />
              <p class="myInputError mt-2">
                {{ errors[0] }}
              </p>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-lg-12 row mt-3"
             v-show="voucherType === 2">
          <div class="col-lg-1 offset-lg-4">
            <label for="fromWho">{{ $t('fields.fromWho') }}</label>
          </div>
          <div class="col-lg-3">
            <ValidationProvider
              name="fromWho"
              :rules="voucherType === 2 ? 'required' : ''"
              v-slot="{errors, classes}">
              <b-form-input
                id="fromWho"
                v-model="fromWho"
                :class="{...classes, myInput: true}" />
              <p class="myInputError mt-2">
                {{ errors[0] }}
              </p>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-lg-12 row mt-3">
          <div class="col-lg-1 offset-lg-4">
            <label for="validTo">{{ $t('fields.validTo') }}</label>
          </div>
          <div class="col-lg-3">
            <ValidationProvider
              name="validTo"
              rules="required"
              v-slot="{errors, classes}">
              <b-form-input
                id="validTo"
                type="date"
                v-model="validTo"
                :class="{...classes, myInput: true}" />
              <p class="myInputError mt-2">
                {{ errors[0] }}
              </p>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-lg-12 text-center">
          <b-button
            class="mt-3 myButton align-middle"
            type="submit">
            {{ $t('EditMoneyVoucher.EditVoucher') }}
          </b-button>
          <b-spinner
            v-show="editing"
            variant="primary"
            class="align-middle ml-3"
            label="Spinning" />
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';

export default {
  name: 'EditProductVoucher',
  data() {
    return {
      editing: false
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    validTo: {
      get() {
        return this.$moment(this.$store.state.editProductVoucher.validTo || new Date()).format('YYYY-MM-DD');
      },
      set(val) {
        this.setValidTo(val);
      }
    },
    forWho: {
      get() {
        return this.$store.state.editProductVoucher.forWho;
      },
      set(val) {
        this.setForWho(val);
      }
    },
    fromWho: {
      get() {
        return this.$store.state.editProductVoucher.fromWho;
      },
      set(val) {
        this.setFromWho(val);
      }
    },
    ...mapState('editProductVoucher', ['voucherType'])
  },
  mounted() {
    this.resetContext();
    this.setProductVoucherId(this.id);
    this.fetchProductVoucher();
  },
  methods: {
    ...mapMutations({
      setProductVoucherId: 'editProductVoucher/setProductVoucherId',
      setValidTo: 'editProductVoucher/setValidTo',
      setForWho: 'editProductVoucher/setForWho',
      setFromWho: 'editProductVoucher/setFromWho'
    }),
    ...mapActions({ fetchProductVoucher: 'editProductVoucher/fetchProductVoucher',
      resetContext: 'editProductVoucher/resetContext',
      editVoucher: 'editProductVoucher/editVoucher' }),
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.editing = true;
        this.editVoucher()
          .then(() => {
            this.editing = false;
            this.resetContext();
            this.$root.$bvToast.toast(this.$t('EditMoneyVoucher.SuccessToast.Body'), {
              title: this.$t('EditMoneyVoucher.SuccessToast.Title'),
              variant: 'success',
              toaster: 'b-toaster-top-right'
            });
            this.$router.replace({ name: 'admin.vouchers.view' });
          })
          .catch(() => {
            this.$root.$bvToast.toast(this.$t('EditMoneyVoucher.FailToast.Body'), {
              title: this.$t('EditMoneyVoucher.FailToast.Title'),
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            });
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
